import { useEffect, useState } from "react";
import { getProductHighlightStrips } from "@/api/public.api.js";

/**
 * Loads cached highlight strip products (nouveaux / restockés) once.
 */
export function useProductHighlightStrips(enabled = true) {
    const [newlyPublished, setNewlyPublished] = useState([]);
    const [restocked, setRestocked] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!enabled) {
            setNewlyPublished([]);
            setRestocked([]);
            setLoaded(true);
            return undefined;
        }
        let cancelled = false;
        (async () => {
            try {
                const response = await getProductHighlightStrips();
                if (!cancelled) {
                    setNewlyPublished(response?.newlyPublished || []);
                    setRestocked(response?.restocked || []);
                }
            } catch {
                if (!cancelled) {
                    setNewlyPublished([]);
                    setRestocked([]);
                }
            } finally {
                if (!cancelled) {
                    setLoaded(true);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [enabled]);

    return { newlyPublished, restocked, loaded };
}
